import { canAccess } from "../../utils/access";

const HOME_ICON =
  "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6";

// Sidebar sections, most important first. An item shows only to roles that can
// access its section (utils/access.js), and a group left empty is hidden.
// paths lists the routes that mark the item active, when it is not just `to`.
export const NAV_GROUPS = [
  {
    items: [
      {
        section: "dashboard",
        to: "/dashboard",
        paths: ["/dashboard", "/income"],
        label: "Хяналтын самбар",
        icon: HOME_ICON,
      },
      {
        section: "tenantDashboard",
        to: "/tenant",
        label: "Хяналтын самбар",
        icon: HOME_ICON,
      },
    ],
  },
  {
    title: "Үйл ажиллагаа",
    items: [
      {
        section: "printer",
        to: "/printer",
        label: "Киоск",
        icon: "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z",
      },
      {
        section: "service",
        to: "/service",
        label: "Үйлчилгээ",
        icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
      },
      {
        section: "printErrors",
        to: "/print-errors",
        label: "Хэвлэлтийн алдаа",
        icon: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
      },
      {
        section: "templates",
        to: "/templates",
        paths: ["/templates", "/template-edit", "/template-themes"],
        label: "Загвар",
        icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
      },
      {
        section: "ads",
        to: "/ads",
        paths: ["/ads", "/ad-report"],
        label: "Реклам",
        icon: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z",
      },
      {
        section: "partners",
        to: "/partners",
        label: "Хамтрагчийн хүсэлт",
        icon: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
      },
    ],
  },
  {
    title: "Санхүү",
    items: [
      {
        section: "log",
        to: "/log",
        label: "Гүйлгээ",
        icon: "M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z",
      },
      {
        section: "ebarimt",
        to: "/ebarimt",
        label: "И-баримт",
        icon: "M9 8h6m-6 4h6m-6 4h6M6 3v18l2-2 2 2 2-2 2 2 2-2 2 2V3l-2 2-2-2-2 2-2-2-2 2-2-2Z",
      },
      {
        section: "bundles",
        to: "/bundles",
        label: "Багц",
        icon: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10",
      },
      {
        section: "plan",
        to: "/plan",
        label: "Орлогын зорилт",
        icon: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6",
      },
    ],
  },
  {
    title: "Бусад",
    items: [
      {
        section: "satisfaction",
        to: "/satisfaction",
        label: "Сэтгэл ханамж",
        icon: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
      },
      {
        section: "admins",
        to: "/users",
        label: "Ажилтан",
        icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
      },
      {
        section: "tenants",
        to: "/tenants",
        label: "Түрээслэгч",
        icon: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
      },
      {
        section: "settings",
        to: "/settings",
        label: "Тохиргоо",
        icon: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4",
      },
    ],
  },
];

export const navGroupsFor = (user) =>
  NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => canAccess(user, item.section)),
  })).filter((group) => group.items.length > 0);

// Where a user lands after login: the first section they can open. Roles with
// none keep the old default.
export const homePathFor = (user) => {
  const groups = navGroupsFor(user);
  return groups.length > 0 ? groups[0].items[0].to : "/printer";
};
